import React from 'react';
import { useAddHouseholdForm } from '../hooks/useAddHouseholdForm';
import { Button, Dialog, DialogBody, DialogFooter, Field, Input } from './ui';

interface AddHouseholdModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddHouseholdModal: React.FC<AddHouseholdModalProps> = ({ isOpen, onClose }) => {
  const {
    name,
    setName,
    handleSubmit,
    isSubmitting,
    canSubmit
  } = useAddHouseholdForm(onClose);

  return (
    <Dialog open={isOpen} onClose={onClose} title="Add New Household">
      <form onSubmit={handleSubmit} className="flex min-h-0 flex-1 flex-col">
        <DialogBody>
          <Field label="Household Name" htmlFor="householdName">
            <Input
              type="text"
              id="householdName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Smith Residence"
              required
              disabled={isSubmitting}
            />
          </Field>
        </DialogBody>

        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="primary" loading={isSubmitting} disabled={!canSubmit}>
            Add Household
          </Button>
        </DialogFooter>
      </form>
    </Dialog>
  );
};

export default AddHouseholdModal;
